export default "__VITE_ASSET__BYhdLqrI__"